import "./Footer.scss";
import { define, mount } from "../../../Lib/registry";
import type { Component } from "../../../Lib/types";

class Footer implements Component {
  readonly el: HTMLElement;

  constructor(el: HTMLElement) {
    this.el = el;
    mount(el);
    this.init();
  }

  private init(): void {}

  destroy(): void {}
}

define("footer", (el) => new Footer(el));
